import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
const InfoPage = () => {
    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div className="icons">
                        {" "}
                        <InfoCircleOutlined />{" "}
                    </div>
                    <h2
                        style={{
                            textAlign: "center",
                            letterSpacing: "2.5px",
                            marginTop: "1rem",
                            color: "grey",
                        }}
                    >
                        Please visit the url with a valid tour-id. Currently no available pre-departure information on
                        tour!
                    </h2>
                </div>
            </div>
        </div>
    );
};

export default InfoPage;
